// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2yHGu","loaderOuter":"PageOverlayLoader_loaderOuter__UWxos"};